<template>
	<router-view />
</template>

<script>
export default {
	data() {
		return {
			isCollapse: false,
			icon_expand: 'el-icon-s-fold',
			aside_width: 'm-expand',
			menus: [],
			menuLoaded: false
		};
	},
	beforeCreate() {
		document.title = "新建造"
		document.querySelector('body').setAttribute('style', 'margin: 0px;');
	},
	async created() {
		
	},
	
};
</script>

<style>
    html,body,#app{
      height: 100%;
      background-color: #f8f8f8;
    }
.scroll { overflow: auto; }

.ml1 { margin-left: 1px; }
.ml2 { margin-left: 2px; }
.ml3 { margin-left: 3px; }
.ml4 { margin-left: 4px; }
.ml5 { margin-left: 5px; }
.ml6 { margin-left: 6px; }
.ml7 { margin-left: 7px; }
.ml8 { margin-left: 8px; }
.ml9 { margin-left: 9px; }
.ml10 { margin-left: 10px; }
.ml15 { margin-left: 15px; }
.ml20 { margin-left: 20px; }
.ml25 { margin-left: 25px; }
.ml30 { margin-left: 30px; }
.mt1 { margin-top: 1px; }
.mt2 { margin-top: 2px; }
.mt3 { margin-top: 3px; }
.mt4 { margin-top: 4px; }
.mt5 { margin-top: 5px; }
.mt6 { margin-top: 6px; }
.mt7 { margin-top: 7px; }
.mt8 { margin-top: 8px; }
.mt9 { margin-top: 9px; }
.mt10 { margin-top: 10px; }
.mt15 { margin-top: 15px; }
.mt20 { margin-top: 20px; }
.mt25 { margin-top: 25px; }
.mt30 { margin-top: 30px; }
.mr1 { margin-right: 1px; }
.mr2 { margin-right: 2px; }
.mr3 { margin-right: 3px; }
.mr4 { margin-right: 4px; }
.mr5 { margin-right: 5px; }
.mr6 { margin-right: 6px; }
.mr7 { margin-right: 7px; }
.mr8 { margin-right: 8px; }
.mr9 { margin-right: 9px; }
.mr10 { margin-right: 10px; }
.mr15 { margin-right: 15px; }
.mr20 { margin-right: 20px; }
.mr25 { margin-right: 25px; }
.mr30 { margin-right: 30px; }
.mb1 { margin-bottom: 1px; }
.mb2 { margin-bottom: 2px; }
.mb3 { margin-bottom: 3px; }
.mb4 { margin-bottom: 4px; }
.mb5 { margin-bottom: 5px; }
.mb6 { margin-bottom: 6px; }
.mb7 { margin-bottom: 7px; }
.mb8 { margin-bottom: 8px; }
.mb9 { margin-bottom: 9px; }
.mb10 { margin-bottom: 10px; }
.mb15 { margin-bottom: 15px; }
.mb20 { margin-bottom: 20px; }
.mb25 { margin-bottom: 25px; }
.mb30 { margin-bottom: 30px; }
.pl1 { padding-left: 1px; }
.pl2 { padding-left: 2px; }
.pl3 { padding-left: 3px; }
.pl4 { padding-left: 4px; }
.pl5 { padding-left: 5px; }
.pl6 { padding-left: 6px; }
.pl7 { padding-left: 7px; }
.pl8 { padding-left: 8px; }
.pl9 { padding-left: 9px; }
.pl10 { padding-left: 10px; }
.pl15 { padding-left: 15px; }
.pl20 { padding-left: 20px; }
.pl25 { padding-left: 25px; }
.pl30 { padding-left: 30px; }
.pt1 { padding-top: 1px; }
.pt2 { padding-top: 2px; }
.pt3 { padding-top: 3px; }
.pt4 { padding-top: 4px; }
.pt5 { padding-top: 5px; }
.pt6 { padding-top: 6px; }
.pt7 { padding-top: 7px; }
.pt8 { padding-top: 8px; }
.pt9 { padding-top: 9px; }
.pt10 { padding-top: 10px; }
.pt15 { padding-top: 15px; }
.pt20 { padding-top: 20px; }
.pt25 { padding-top: 25px; }
.pt30 { padding-top: 30px; }
.pr1 { padding-right: 1px; }
.pr2 { padding-right: 2px; }
.pr3 { padding-right: 3px; }
.pr4 { padding-right: 4px; }
.pr5 { padding-right: 5px; }
.pr6 { padding-right: 6px; }
.pr7 { padding-right: 7px; }
.pr8 { padding-right: 8px; }
.pr9 { padding-right: 9px; }
.pr10 { padding-right: 10px; }
.pr15 { padding-right: 15px; }
.pr20 { padding-right: 20px; }
.pr25 { padding-right: 25px; }
.pr30 { padding-right: 30px; }
.pb1 { padding-bottom: 1px; }
.pb2 { padding-bottom: 2px; }
.pb3 { padding-bottom: 3px; }
.pb4 { padding-bottom: 4px; }
.pb5 { padding-bottom: 5px; }
.pb6 { padding-bottom: 6px; }
.pb7 { padding-bottom: 7px; }
.pb8 { padding-bottom: 8px; }
.pb9 { padding-bottom: 9px; }
.pb10 { padding-bottom: 10px; }
.pb15 { padding-bottom: 15px; }
.pb20 { padding-bottom: 20px; }
.pb25 { padding-bottom: 25px; }
.pb30 { padding-bottom: 30px; }
.pd1 { padding: 1px; }
.pd2 { padding: 2px; }
.pd3 { padding: 3px; }
.pd4 { padding: 4px; }
.pd5 { padding: 5px; }
.pd6 { padding: 6px; }
.pd7 { padding: 7px; }
.pd8 { padding: 8px; }
.pd9 { padding: 9px; }
.pd10 { padding: 10px; }
.pd15 { padding: 15px; }
.pd20 { padding: 20px; }
.pd25 { padding: 25px; }
.pd30 { padding: 30px; }
.br1 { border-radius: 1px; }
.br2 { border-radius: 2px; }
.br3 { border-radius: 3px; }
.br4 { border-radius: 4px; }
.br5 { border-radius: 5px; }
.br6 { border-radius: 6px; }
.br7 { border-radius: 7px; }
.br8 { border-radius: 8px; }
.br9 { border-radius: 9px; }
.br10 { border-radius: 10px; }
.br15 { border-radius: 15px; }
.br20 { border-radius: 20px; }
.br25 { border-radius: 25px; }
.br30 { border-radius: 30px; }
.mg1 { margin: 1px; }
.mg2 { margin: 2px; }
.mg3 { margin: 3px; }
.mg4 { margin: 4px; }
.mg5 { margin: 5px; }
.mg6 { margin: 6px; }
.mg7 { margin: 7px; }
.mg8 { margin: 8px; }
.mg9 { margin: 9px; }
.mg10 { margin: 10px; }
.mg15 { margin: 15px; }
.mg20 { margin: 20px; }
.mg25 { margin: 25px; }
.mg30 { margin: 30px; }
.fs12 { font-size: 12px; }
.fs13 { font-size: 13px; }
.fs14 { font-size: 14px; }
.fs15 { font-size: 15px; }
.fs16 { font-size: 16px; }
.fs17 { font-size: 17px; }
.fs18 { font-size: 18px; }
.fs19 { font-size: 19px; }
.fs20 { font-size: 20px; }
.fs21 { font-size: 21px; }
.fs22 { font-size: 22px; }
.fs23 { font-size: 23px; }
.fs24 { font-size: 24px; }
.fs25 { font-size: 25px; }
.fs26 { font-size: 26px; }
.fs27 { font-size: 27px; }
.fs28 { font-size: 28px; }
.fs29 { font-size: 29px; }
.fs30 { font-size: 30px; }
.fs31 { font-size: 31px; }
.fs32 { font-size: 32px; }
.fs33 { font-size: 33px; }
.fs34 { font-size: 34px; }
.fs35 { font-size: 35px; }
.fs36 { font-size: 36px; }
.fs37 { font-size: 37px; }
.fs38 { font-size: 38px; }
.fs39 { font-size: 39px; }
.fs40 { font-size: 40px; }
.a5 { opacity: 0.05; }
.a10 { opacity: 0.1; }
.a15 { opacity: 0.15; }
.a20 { opacity: 0.2; }
.a25 { opacity: 0.25; }
.a30 { opacity: 0.3; }
.a35 { opacity: 0.35; }
.a40 { opacity: 0.4; }
.a45 { opacity: 0.45; }
.a50 { opacity: 0.5; }
.a55 { opacity: 0.55; }
.a60 { opacity: 0.6; }
.a65 { opacity: 0.65; }
.a70 { opacity: 0.7; }
.a75 { opacity: 0.75; }
.a80 { opacity: 0.8; }
.a85 { opacity: 0.85; }
.a90 { opacity: 0.9; }
.a95 { opacity: 0.95; }
.bold { font-weight: bold; }
.w100 { width: 100%; }
.h100 { height: 100%; }
.flex-width { flex: 1; width: 0; }
.flex-height { flex: 1; height: 0; }
.flex { display: flex; }
.flex-reverse { display: flex; flex-direction: row-reverse; }
.flex-column { display: flex; flex-direction: column; }
.items-center { align-items: center; }
.content-center { justify-content: center; }
.flex-1 { flex: 1; }
.relative { position: relative; }
.absolute { position: absolute; }
.overflow-hidden { overflow: hidden; }
.text-center { text-align: center; }
.cursor-pointer { cursor: pointer; }
.bg-white { background: white; }
</style>
